/**
 * BookingForm — thin dialog wrapper around the V2 form engine
 * (`BookingFormShell`). Kept as a named component so every caller
 * (Bookings.jsx, DockManager.jsx, NewBookingEdit.jsx, etc.) can go on
 * importing `@/components/BookingForm` unchanged.
 *
 * History
 *   Feb 2026 — introduced as a V1/V2 dispatcher during the form-engine
 *              rewrite; V2 shipped as default with `?bf=v1` opt-out.
 *   Jul 2026 — R-1 refactor: V1 body + 7 legacy *Tab.jsx files deleted.
 *              This file is now a pure wrapper. `?bf=v1` is a no-op.
 */
import { Dialog, DialogContent } from "@/components/ui/dialog";
import BookingFormShell from "@/components/booking-form/BookingFormShell";

export default function BookingForm({
  open,
  onOpenChange,
  booking,
  defaultSiteId,
  defaultBayId,
  prefill,
  onSaved,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-3xl max-h-[92vh] overflow-y-auto"
        data-testid="booking-form-dialog"
        data-bf-engine="v2"
      >
        {open && (
          <BookingFormShell
            key={booking?.id || "new"}
            booking={booking}
            defaultSiteId={defaultSiteId}
            defaultBayId={defaultBayId}
            prefill={prefill}
            onOpenChange={onOpenChange}
            onSaved={onSaved}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
